import { toastr } from 'react-redux-toastr';
import i18next from 'i18next';
import {
    FETCH_RESTAURANTS,
    FETCH_RESTAURANT,
    SAVE_RESTAURANT,
    DELETE_RESTAURANT,
    UPDATE_ENTITY_FIELD,
    FETCH_RESTAURANT_SALES_DATA,
    FETCH_ARCHIVED_RESTAURANTS
} from '../types';
import api from '../api';
import countries from '../../consts/Countries.json';
import timezones from '../../consts/Timezones.json';
import TaxSetups from '../../consts/TaxSetups.json';

export const fetchRestaurants = (ids) => {
    return {
        type: FETCH_RESTAURANTS,
        payload: api.restaurant.getAll(ids, false),
    };
};

export const fetchArchivedRestaurants = (ids, onSuccess) => {
    return {
        type: FETCH_ARCHIVED_RESTAURANTS,
        payload: api.restaurant.getAll(ids, true),
        meta: { onSuccess }
    };
};

export const fetchRestaurant = (id) => {
    return {
        type: FETCH_RESTAURANT,
        payload: api.restaurant.getAll([id]),
    };
};

export const saveRestaurant = (rest) => {
    if (rest.id) {
        return {
            type: SAVE_RESTAURANT,
            payload: api.restaurant.update(rest),
            meta: { restId: rest.id, toastSuccess: true }
        };
    } else {
        return {
            type: SAVE_RESTAURANT,
            payload: api.restaurant.create(rest),
            meta: { toastSuccess: true }
        };
    }
};

export const deleteRestaurant = (restId) => {
    return {
        type: DELETE_RESTAURANT,
        payload: api.restaurant.delete(restId),
        meta: { restId, toastSuccess: true }
    };
};

export const fetchRestaurantSalesData = (restId, salesSystemId, callback = () => null) => {
    return {
        type: FETCH_RESTAURANT_SALES_DATA,
        payload: api.restaurant.get(restId).salesData(salesSystemId),
        meta: { restId, onSuccess: callback }
    };
};

export const fetchRestaurantDataFromGoogle = (search, lang = i18next.language) => {
    return dispatch => {
        api.google.address(search, lang).then(({ data }) => {
            if (data && data.results && data.results.length) {
                const result = data.results[0];

                dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'address', value: result.formatted_address } });

                if (result.formatted_phone_number) {
                    dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'phone', value: result.formatted_phone_number } });
                }

                if (result.geometry) {
                    const { lat, lng } = result.geometry.location;
                    dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'lat', value: lat } });
                    dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'lng', value: lng } });
                }

                const countryComponent = result.address_components.find(address => address.types && address.types.indexOf('country') >= 0);
                if (countryComponent) {
                    const country_code = countryComponent.short_name;
                    const country = countries.find(c => c.alpha_2 === country_code || c.alpha_3 === country_code);
                    const timezone = timezones.find(t => t.country_code === country_code).timezones[0];
                    const taxesSetup = TaxSetups.find(t => t.countryCode == country_code);

                    dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'countryCode', value: country_code } });
                    dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'timezone', value: timezone } });
                    dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'currencyCode', value: country.currency_code } });
                    if (taxesSetup) dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'taxesSetup', value: taxesSetup.setup } });
                }

                if (result.place_id) {
                    dispatch({ type: UPDATE_ENTITY_FIELD, payload: { key: 'placeId', value: result.place_id } });
                }
            }
        }).catch((err) => { toastr.error('Error', err); });
    };
};
